const qualifier = process.env.QUALIFIER
const env = process.env.ENVIRONMENT

const GATEWAY_URL = {
    'https://test.chotel.com:9000': 'https://hog-gw-v1-core-ota-dev.distdev.cloud.chotel.com:8443/v1/hotel-onboarding/',
    'https://choicepropel-core-ota-dev.distdev.cloud.chotel.com': 'https://hog-gw-v1-core-ota-dev.distdev.cloud.chotel.com:8443/v1/hotel-onboarding/',
    'https://propel-core-ec-sit.distdev.cloud.chotel.com': 'https://hog-gw-v1-core-ec-sit.distdev.cloud.chotel.com:8443/v1/hotel-onboarding/',
    'https://choicepropel-core-ec-sit.distdev.cloud.chotel.com': 'https://hog-gw-v1-core-ec-sit.distdev.cloud.chotel.com:8443/v1/hotel-onboarding/',
    'https://choicepropel-core-ec-rit.distpreprod.cloud.chotel.com': 'https://hog-gw-v1-core-ec-rit.distpreprod.cloud.chotel.com:8443/v1/hotel-onboarding/',
    'https://choicepropel-core-ec-prod.distprod.cloud.chotel.com': 'https://hog-gw-v1-core-ec-prod.distprod.cloud.chotel.com:8443/v1/hotel-onboarding/',
    'https://choicepropel-core-ec-prod.distprod.cloud.choicehotels.com': 'https://hog-gw-v1-core-ec-prod.distprod.cloud.choicehotels.com/v1/hotel-onboarding/'
}

const HOTEL_ONBOARDING_HISTORY_URL = {
    'https://choicepropel-core-ota-dev.distdev.cloud.chotel.com': 'https://hog-gw-v1-core-ota-dev.distdev.cloud.chotel.com:8443/v1/hotel-onboarding-history/',
    'https://choicepropel-dev.distdev.cloud.chotel.com': 'https://hog-gw-v1-dev.distdev.cloud.chotel.com:8443/v1/hotel-onboarding-history/',
    'https://propel-core-ec-sit.distdev.cloud.chotel.com': 'https://hog-gw-v1-core-ec-sit.distdev.cloud.chotel.com:8443/v1/hotel-onboarding-history/',
    'https://choicepropel-core-ec-sit.distdev.cloud.chotel.com': 'https://hog-gw-v1-core-ec-sit.distdev.cloud.chotel.com:8443/v1/hotel-onboarding-history/',
    'https://choicepropel-core-ec-rit.distpreprod.cloud.chotel.com': 'https://hog-gw-v1-core-ec-rit.distpreprod.cloud.chotel.com:8443/v1/hotel-onboarding-history/',
    'https://choicepropel-core-ec-prod.distprod.cloud.chotel.com': 'https://hog-gw-v1-core-ec-prod.distprod.cloud.chotel.com:8443/v1/hotel-onboarding-history/',
    'https://choicepropel-core-ec-prod.distprod.cloud.choicehotels.com': 'https://hog-gw-v1-core-ec-prod.distprod.cloud.choicehotels.com/v1/hotel-onboarding-history/',
    'https://test.chotel.com:9000': 'https://hog-gw-v1-core-ec-sit.distdev.cloud.chotel.com:8443/v1/hotel-onboarding-history/'
}

const OKTA_HOME_URL = {
    'https://test.chotel.com:9000': 'https://choicehotels.oktapreview.com/',
    'https://choicepropel-core-ota-dev.distdev.cloud.chotel.com': 'https://choicehotels.oktapreview.com/',
    'https://propel-core-ec-sit.distdev.cloud.chotel.com': 'https://choicehotels.oktapreview.com/',
    'https://choicepropel-core-ec-sit.distdev.cloud.chotel.com': 'https://choicehotels.oktapreview.com/',
    'https://choicepropel-core-ec-rit.distpreprod.cloud.chotel.com': 'https://choicehotels.oktapreview.com/',
    'https://choicepropel-core-ec-prod.distprod.cloud.choicehotels.com': 'https://choicehotels.okta.com/',
    'https://choicepropel-core-ec-prod.distprod.cloud.chotel.com': 'https://choicehotels.okta.com/'
}

export default {
    // GATEWAY
    HOTEL_ONBOARDING_SERVICE: GATEWAY_URL[window.location.origin],
    PATH_ACQUIRE_USER: '{hotelCode}/acquireUser',
    PATH_AGE_TIERS: '{hotelCode}/age-tiers',
    PATH_BASIC_HOTEL_INFO: '{hotelCode}/basic-hotelInfo',
    PATH_BASIC_HOTELS_INFO_WITH_BRAND_AND_NAME: 'properties-with-brand',
    PATH_BASE_RATE_PLANS: '{hotelCode}/base-rateplans',
    PATH_BOX_INVENTORY: '{hotelCode}/box-inventories',
    PATH_SRP_INVENTORY: '{hotelCode}/srp-inventories',
    PATH_COMMENTS: '{hotelCode}/comments',
    PATH_COUNTRIES: '{hotelCode}/countries',
    PATH_DASHBOARD_SUMMARY: 'dashboard-summary',
    PATH_DESTINATIONS: '{hotelCode}/destinations',
    PATH_DESTINATION_ACCEPTABLE_VALUES: '{hotelCode}/hotel-reference',
    PATH_EXTRA_CHARGES: '{hotelCode}/extra-charges',
    PATH_GROUP_POLICY: '{hotelCode}/group-policy',
    PATH_GUARANTEE_CANCEL_POLICY: '{hotelCode}/guarantee-cancel-policy',
    PATH_HOTEL_AMENITIES: '{hotelCode}/hotel-amenities',
    PATH_HOTEL_CLOSEOUTS: '{hotelCode}/closeout',
    PATH_HOTEL_CONTACTS: '{hotelCode}/contacts',
    PATH_HOTEL_INFO: '{hotelCode}/hotelInfo',
    PATH_HOTEL_INFO_POST: 'hotelInfo',
    PATH_HOTEL_ONBOARDING_CONTACT_INITIAL: '{hotelCode}/opd/contacts',
    PATH_HOTEL_ONBOARDING_STATUS: 'status',
    PATH_HOTEL_ONBOARDING_STATUS_PUT: '{hotelOnboardingId}/status',
    PATH_HOTEL_TAXES: '{hotelCode}/hotel-charges',
    PATH_HOTEL_CONTENT: '{hotelCode}/content',
    PATH_HOTEL_TEXT: '{hotelCode}/hotel-text',
    PATH_IATA_LOCATIONS: '{hotelCode}/iata-locations',
    PATH_MASTER_HOTEL_AMENITIES: '{hotelCode}/master-hotel-amenities',
    PATH_ROOM_TYPES: '{hotelCode}/room-types',
    PATH_ROOM_TYPE_BUCKETS: '{hotelCode}/room-type-buckets',
    PATH_MASTER_ROOM_TYPES: '{hotelCode}/master-room-types',
    PATH_MASTER_ROOM_AMENITIES: '{hotelCode}/master-room-amenities',
    PATH_MEETING_ROOM_AMENITIES: '{hotelCode}/meeting-room-amenities',
    PATH_MASTER_ROOM_AMENITIES_BRAND_SPECIFIC: '{hotelCode}/master-room-amenities?searchByTags=true',
    PATH_MEETING_ROOMS: '{hotelCode}/meeting-rooms',
    PATH_OTA_RATE_PROGRAMS: '{hotelCode}/ota-rate-programs',
    PATH_PET_POLICY: '{hotelCode}/pet-policy',
    PATH_RATE_PLANS: '{hotelCode}/rateplans',
    PATH_RATE_PLANS_STANDARD: '{hotelCode}/standard-rateplans',
    PATH_RATEPLAN_BLACKOUTS: '{hotelCode}/blackout',
    PATH_RESET_USER: '{hotelCode}/resetUser',
    PATH_TERMS_AND_CONDITIONS: '{hotelOnboardingId}/terms-conditions',
    PATH_HOTEL_RECAP_POST: '{hotelCode}/recap',
    PATH_CONFIGURE_RATE_PLANS_GET: 'rateplan/configs',
    PATH_CONFIGURE_RATE_PLANS_POST: 'rateplan/config',
    PATH_CONFIGURE_RATE_PLANS_PUT_DELETE: '{code}/rateplan/config',
    PATH_CONFIGURE_RATES_GET_POST: 'rates/config',
    PATH_CONFIGURE_RATES_PUT_DELETE: '{code}/rates/config',
    PATH_CONFIGURE_MASTER_BOX_GET: 'masterbox/configs',
    PATH_CONFIGURE_MASTER_BOX_POST: 'masterbox/config',
    PATH_CONFIGURE_MASTER_BOX_PUT_DELETE: '{boxName}/masterbox/config',
    // OKTA
    OKTA_SERVICE: OKTA_HOME_URL[window.location.origin],
    PATH_OKTA_ISSUER: 'oauth2/default',
    PATH_OKTA_LOGOUT_REDIRECT: 'app/UserHome',
    HOTEL_ONBOARDING_HISTORY_SERVICE: HOTEL_ONBOARDING_HISTORY_URL[window.location.origin],
    PATH_HISTORY_SUMMARY: 'historysummary?hotelCode={hotelCode}',
    PATH_HISTORY_RECORD_DETAILS: 'history?hotelOnboardingId={hotelOnboardingId}'
}